export default __webpack_public_path__ + "static/media/Ms. Jayashree Rana.cc0a1af5.png";